/**
 * How often each SecurOne screen re-reads the server when nothing pushed.
 *
 * Three screens polled on three different rhythms, all of them chosen before the
 * socket existed, and the notification watcher polled every customer the account
 * reaches every ten seconds on *every page in SecurCloud* — not only inside
 * SecurOne. That is a request per customer, six times a minute, all day, to
 * notice something the socket reports in under a second.
 *
 * So each poll now has two speeds. With the socket connected it is a safety net
 * against a missed ping and runs slowly; without it — no socket, or a database
 * with no replica set, where the server's change streams are unavailable and
 * warn once at boot — it is the only thing that notices, and keeps the old
 * timings. `securone.socket.isConnected()` chooses.
 */
export const POLL = {
  // The broadcast watcher: one request per customer the account reaches.
  notificationsSocket: 60000,
  notificationsNoSocket: 10000,

  // The event list.
  eventsSocket: 60000,
  eventsNoSocket: 5000,

  // One open event: status, acknowledgements, chat, log. The fastest of the
  // three even on the socket, because somebody is watching it happen.
  detailSocket: 30000,
  detailNoSocket: 3000,
};

export default POLL;
